module.exports = __webpack_public_path__ + "static/media/recorded.5d8bf6b7.png";